import { getApiBaseUrl, fetchWithAuth } from './api';
import { okJson } from './httpError';
import type { VisitorAuthorizerImpact } from '../pages/visitorAuthorizer';

const base = () => getApiBaseUrl();

/**
 * Who may authorize a visitor.
 *
 * The choice itself lives in customer settings and travels with the rest of them — see
 * CustomerSettings. These two calls are the parts that do not: the census behind the warning, and
 * the per-person exception.
 */

/**
 * How many people hold each relation, so the settings screen can say what a choice will do before
 * it is saved. Staff only, server-side.
 */
export async function getVisitorAuthorizerImpact(
  customerId: string,
): Promise<VisitorAuthorizerImpact> {
  const r = await fetchWithAuth(
    `${base()}/api/v1/customers/${customerId}/visitor-authorizer/impact`,
  );
  return okJson(r, 'Erro ao calcular quem poderá liberar visitantes');
}

/**
 * Grants or withdraws one person's exception to the relation rule.
 *
 * There is deliberately no self-service counterpart: a flag its own holder could set is not a
 * permission.
 */
export async function setVisitorAuthorizerFlag(
  customerId: string,
  personId: string,
  canAuthorizeVisitors: boolean,
): Promise<void> {
  const r = await fetchWithAuth(
    `${base()}/api/v1/customers/${customerId}/people/${personId}/visitor-authorizer`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ can_authorize_visitors: canAuthorizeVisitors }),
    },
  );
  await okJson(r, 'Erro ao salvar a permissão de liberar visitantes');
}
